import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  Image,
  Row,
  Spinner,
} from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import { getError } from "../utils/error";
import FormField from "../components/layout/FormField";
import {
  useForgetPasswordMutation,
  useNewPasswordMutation,
  useResendOTPMutation,
  useSubmitOTPMutation,
} from "../features/apiSlice";
import { BsArrowLeft, BsArrowRight } from "react-icons/bs";

export default function ForgetPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [newPasswords, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [check, setCheck] = useState(false);
  const [otpCheck, setOTPCheck] = useState(false);
      const [counter, setCounter] = useState(90);
      useEffect(() => {
        let timer;
        if (counter > 0) {
            timer = setTimeout(() => setCounter(counter - 1), 1000);
        }
        return () => {
            clearTimeout(timer);
        };
    }, [counter]);
  
    const formatCounter = (count) => {
        const minutes = Math.floor(count / 60);
        const seconds = count % 60;
        return `${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    };
  
  const [forgetPassword, { isLoading }] = useForgetPasswordMutation();
  const [resendOTP, { isLoading:resendLoading }] = useResendOTPMutation();
  const [
    newPassword,
    {
      isLoading: { newPasswordLoading },
    },
  ] = useNewPasswordMutation();
  const [
    submitOTP,
    {
      isLoading: { otpLoading },
    },
  ] = useSubmitOTPMutation();

  const [otp, setOtp] = useState(new Array(4).fill(""));
  const inputs = useRef([]);
  const [otps, setOtps] = useState(0);

  const handleChange = (element, index) => {
    if (isNaN(element.value)) return;

    let newOtp = [...otp];
    newOtp[index] = element.value;
    setOtp(newOtp);

    if (element.value !== "" && index < 4 - 1) {
      inputs.current[index + 1].focus();
    }
    setOtps(newOtp.join(""));
  };

  const handleKeyUp = (e, index) => {
    if (e.keyCode === 8 && index > 0) {
      inputs.current[index - 1].focus();
    }
  };

  const handleForget = async (e) => {
    e.preventDefault();
    if (!check && !otpCheck) {
      try {
        await forgetPassword({ email }).unwrap();
        localStorage.setItem("email", email);
        setCheck(true);
        return;
      } catch (error) {
        getError(error);
        return;
      }
    }

    if (!otpCheck) {
      try {
        const mail = localStorage.getItem("email");
        await submitOTP({ email: mail, otp: otps }).unwrap();
        setOTPCheck(true);
        return;
      } catch (error) {
        getError(error);
        return;
      }
    }

    if (check && otpCheck) {
      try {
        const mail = localStorage.getItem("email");
        await newPassword({ email: mail, password: newPasswords }).unwrap();
        navigate("/");
      } catch (error) {
        getError(error);
      }
    }
  };


  const handleResendOTP = async()=>{
    try {

      const data = await forgetPassword({email}).unwrap();
      toast.success('Otp sent')
      setCounter(90); 
      
    } catch (error) {
      getError(error);
    }
  }

  return (
    <Container fluid className="p-0 vh-100 f-center flex-column login-page">
      <div className="login-logo ">
        <Link to="/" className="text-center">
          <Image
            src="/logo/sciendaLogo.png"
            height={"50px"}
            className="border"
          />{" "}
          <b className="fs-1 fw-bold" style={{ color: "rgba(0, 0, 139, 1)" }}>
            Scienda
          </b>
        </Link>
      </div>

      <Card className="login-box shadow">
        <Card.Body>
          <Row>
            <Col className="text-center">
            
          <Image src="/icons/mail.png" style={{height:'50px'}} />
            </Col>
          </Row>
          <Form onSubmit={handleForget}>
            {!check ? (
              <>
          <p className="text-center">To continue please enter your Email.</p>
              <FormField
                placeholder={"Enter your Email"}
                type={"email"}
                label={"Email"}
                onChange={(e) => setEmail(e.target.value)}
                value={email}
              />
              </> 
            ) : (
              <>
                {!otpCheck ? (
                  <>
                    <p className="text-center mb-2">We sent a verification link to <span className="fw-bold">{email}</span>.</p>
                    <div className="otp-input mb-3">
                      {otp.map((data, index) => (
                        <input
                          key={index}
                          type="text"
                          maxLength="1"
                          value={data}
                          onChange={(e) => handleChange(e.target, index)}
                          onKeyUp={(e) => handleKeyUp(e, index)}
                          ref={(el) => (inputs.current[index] = el)}
                        />
                      ))}
                    </div>
                    {counter ==0 ? (
                      <p className='text-secondary'>
                       Didn't receive the email?
                       <span onClick={handleResendOTP} className="blue" style={{ cursor: 'pointer' }}>
                   Click to Resend 
                   </span>
                   .
                   </p>
                                      
                                    ) : (
                                      <p className="text-secondary">Didn't receive the email? Resend OTP in <span className="blue">{formatCounter(counter)}</span>.</p>
                                      )} 
                  </>
                ) : (
                  <>
                    <FormField
                      placeholder={"Enter your Password"}
                      type={"password"}
                      label={"New Password"}
                      onChange={(e) => setNewPassword(e.target.value)}
                      value={newPasswords}
                    />
                    <FormField
                      placeholder={"Enter your Confirm Password"}
                      type={"password"}
                      label={"Confirm Password"}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      value={confirmPassword}
                    />
                  </>
                )}
              </>
            )}

            <Row>
              <Col className="">
                <hr />
                {isLoading || otpLoading || newPasswordLoading ? (
                  <Button type="submit" className="float-sm-end" disabled>
                    <Spinner animation="border" size="sm" />
                  </Button>
                ) : (
                  <Button
                    type="submit"
                    className="float-sm-end w-100 "
                    style={{ background: "rgba(0, 0, 139, 1)" }}
                  >
                   {otpCheck?'Verify Email':'Submit'}
                  </Button>
                )}
              </Col>
            </Row>
          </Form>
          <ToastContainer />
          <Row>

            <Col className="text-center pt-3">
            
          <Link to={'/'} className="blue "><h6><BsArrowLeft size={20} /> Back To Login</h6></Link>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </Container>
  );
}
